import { PublicClientApplication, EventType, AuthenticationResult, LogLevel } from "@azure/msal-browser";


// Funzione per creare la configurazione MSAL
export const getMsalConfig = (clientId: string, tenantId: string) => ({
    auth: {
        clientId,
        authority: `https://login.microsoftonline.com/${tenantId}`,
        redirectUri: window.location.origin,
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false,
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (!containsPii) {
                    switch (level) {
                        case LogLevel.Error:
                            console.error(message);
                            break;
                        case LogLevel.Warning:
                            console.warn(message);
                            break;
                        case LogLevel.Verbose:
                            console.debug(message);
                            break;
                        default:
                            break;
                    }
                }
            }
        }
    }
});


let msalInstance: PublicClientApplication | null = null;

// Inizializza MSAL con le configurazioni caricate
export const initializeMsalInstance = async (clientId: string, tenantId: string) => {
    const config = getMsalConfig(clientId, tenantId);
    msalInstance = new PublicClientApplication(config);
    await msalInstance.initialize();

    const accounts = msalInstance.getAllAccounts();
    if (accounts.length > 0) {
        msalInstance.setActiveAccount(accounts[0]);
    }

    // Callback per eventi di autenticazione
    msalInstance.addEventCallback((event) => {
        if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
            const authResult = event.payload as AuthenticationResult;
            msalInstance!.setActiveAccount(authResult.account);
        }
    });

    return msalInstance;
};

// Restituisce l'istanza di MSAL se è stata inizializzata
export const getMsalInstance = () => {
    if (!msalInstance) {
        throw new Error("MSAL instance not initialized!");
    }
    return msalInstance;
};
